import React from 'react';
import { handleChange } from 'lib/stores/formStore';
import withValidations from 'lib/hocs/withValidations';
import { formatIdFromName } from 'lib/utility';

import FormLabel from './FormLabel';

const FormTextField = ({ name, label, id, value, inputClass, required, hideLabel, disabled }) => (
  <div className="mb-3">
    {!hideLabel && (
      <FormLabel id={id || formatIdFromName(name)} label={label} required={required} />
    )}
    <input
      name={name}
      type="text"
      value={value}
      onChange={handleChange}
      id={id || formatIdFromName(name)}
      data-testid={id || formatIdFromName(name)}
      required={required}
      disabled={disabled}
      className={inputClass}
    />
  </div>
);

export default withValidations({ required: false })(FormTextField);
